namespace GeniuzPOS.Purchase {
    export interface PoPurOrderForm {
        SysDocNo: Serenity.StringEditor;
        PurDocNo: Serenity.StringEditor;
        ShopId: Serenity.StringEditor;
        DocNo: Serenity.StringEditor;
        DocDate: Serenity.DateEditor;
        SupplierId: Serenity.LookupEditor;
        RefDocNo1: Serenity.LookupEditor;
        ConcatRefDocNo1: Serenity.StringEditor;
        RefDocNo2: Serenity.StringEditor;
        BranchCode: Serenity.StringEditor;
        ShipId: Serenity.LookupEditor;
        ShipDate: Serenity.DateEditor;
        WhsId: Serenity.StringEditor;
        ShipName: Serenity.StringEditor;
        ShipLineAddress1: Serenity.StringEditor;
        ShipLineAddress2: Serenity.StringEditor;
        ShipLineAddress3: Serenity.StringEditor;
        VatFg: Serenity.RadioButtonEditor;
        POTypeFg: Serenity.RadioButtonEditor;
        SalesVatTypes: Serenity.LookupEditor;
        DtList: PoPurOrderDtEditor;
        Remark: Serenity.StringEditor;
        TotalAmt: Serenity.DecimalEditor;
        CashOrTermfg: Serenity.RadioButtonEditor;
        PayTermCode: Serenity.LookupEditor;
        DiscText: Serenity.StringEditor;
        DiscAmt: Serenity.DecimalEditor;
        NetAmt: Serenity.DecimalEditor;
        NetExVat: Serenity.DecimalEditor;
        DepositAmt: Serenity.DecimalEditor;
        VatCode: Serenity.LookupEditor;
        VatRate: Serenity.DecimalEditor;
        VatAmt: Serenity.DecimalEditor;
        PurOrderAmt: Serenity.DecimalEditor;
        NetTotalInVat: Serenity.DecimalEditor;
        SendForAppfg: Serenity.EnumEditor;
        CancelFg: Serenity.EnumEditor;
        UseFg: Serenity.IntegerEditor;
        CheckQty: Serenity.IntegerEditor;
        ApproveFg: Serenity.EnumEditor;
    }

    export class PoPurOrderForm extends Serenity.PrefixedContext {
        static formKey = 'Purchase.PoPurOrder';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PoPurOrderForm.init)  {
                PoPurOrderForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.LookupEditor;
                var w3 = s.RadioButtonEditor;
                var w4 = PoPurOrderDtEditor;
                var w5 = s.DecimalEditor;
                var w6 = s.EnumEditor;
                var w7 = s.IntegerEditor;

                Q.initFormType(PoPurOrderForm, [
                    'SysDocNo', w0,
                    'PurDocNo', w0,
                    'ShopId', w0,
                    'DocNo', w0,
                    'DocDate', w1,
                    'SupplierId', w2,
                    'RefDocNo1', w2,
                    'ConcatRefDocNo1', w0,
                    'RefDocNo2', w0,
                    'BranchCode', w0,
                    'ShipId', w2,
                    'ShipDate', w1,
                    'WhsId', w0,
                    'ShipName', w0,
                    'ShipLineAddress1', w0,
                    'ShipLineAddress2', w0,
                    'ShipLineAddress3', w0,
                    'VatFg', w3,
                    'POTypeFg', w3,
                    'SalesVatTypes', w2,
                    'DtList', w4,
                    'Remark', w0,
                    'TotalAmt', w5,
                    'CashOrTermfg', w3,
                    'PayTermCode', w2,
                    'DiscText', w0,
                    'DiscAmt', w5,
                    'NetAmt', w5,
                    'NetExVat', w5,
                    'DepositAmt', w5,
                    'VatCode', w2,
                    'VatRate', w5,
                    'VatAmt', w5,
                    'PurOrderAmt', w5,
                    'NetTotalInVat', w5,
                    'SendForAppfg', w6,
                    'CancelFg', w6,
                    'UseFg', w7,
                    'CheckQty', w7,
                    'ApproveFg', w6
                ]);
            }
        }
    }
}
